<template>
  <div class="header">
    <aside class="aside__top">
      <div class="logoBox">
        <div class="logo">
          <img src="../../../../static/images/main/logo.png" />
        </div>
        <div class="logoText">
          创新教育云平台
        </div>
      </div>
      <div class="aside__top--right">
        <div class="ai-box">
          <el-dropdown trigger="click" @command="clientSelect">
            <span class="el-dropdown-link box-dropdown">
              迪小乐智能AI <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="text-align: center;" command="http://aigc.dlm.plus/">AI助手</el-dropdown-item>
              <!-- <el-dropdown-item style="text-align: center;" command="http://to3d.dlm.plus/">AI工具</el-dropdown-item> -->
              <el-dropdown-item style="text-align: center;" command="http://tool.dlm.plus/">AI工具</el-dropdown-item>
              <el-dropdown-item style="text-align: center;" command="http://aiot.delightmom.com/login">物联网平台</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="message" id="msg">
          <img src="../../../../static/images/main/icon-nav-news.png" @click.stop="showMessage" />
          <span v-show="notifycount+count>0">
            {{notifycount+count>99?'99+':notifycount+count}}
          </span>
          <div class="messageCon" v-show="isShow" @click.stop>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="'通知信息('+notifycount+')'" name="2">
                <div class="empt" v-show="message1.length==0">
                  <img src="../../../../static/images/main/empt.png" />
                  <h3>你已完成所有待办</h3>
                </div>
                <ul v-show="message1.length>0" class="messageList" id="messageList1">
                  <!-- <li v-for="(item,i) in message1" @click="dbMsg('messageList1',i)"><span>{{item.message_name}}</span><i>{{item.createdate}}</i></li> -->
                  <li v-for="(item,i) in message1" @click="dbMsg(item.id)" :class="[item.message_state==1?'':'readMsg']">
                    <div v-html="item.message_content"></div><i>{{item.createdate}}</i>
                  </li>
                  <!-- <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li> -->
                </ul>
              </el-tab-pane>
              <el-tab-pane :label="'待办提醒('+count+')'" name="1">
                <div class="empt" v-show="message2.length==0">
                  <img src="../../../../static/images/main/empt.png" />
                  <h3>你已完成所有待办</h3>
                </div>
                <ul v-show="message2.length>0" class="messageList" id="messageList2">
                  <!-- <li v-for="(item,i) in message2" @click="dbMsg('messageList2',i)"><span>{{item.message_name}}</span><i>{{item.createdate}}</i></li> -->
                  <li v-for="(item,i) in message2" @click="dbMsg(item.id)" :class="[item.message_state==1?'':'readMsg']">
                    <div v-html="item.message_content"></div><i>{{item.createdate}}</i>
                  </li>
                  <!-- <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li>
                  <li><span>【通知】速来围观！！！迪乐姆教师成长平台正式上线啦～</span><i>2021.09.01</i></li> -->
                </ul>
              </el-tab-pane>
            </el-tabs>
            <div class="btnBox" v-if="activeName==2" v-show="message1.length>0">
              <el-button @click="messageyd">一键已读</el-button>
            </div>
            <div class="btnBox" v-else v-show="message2.length>0">
              <el-button @click="messageyd">一键已读</el-button>
            </div>
          </div>
        </div>
        <div class="user-msg">
          <el-dropdown trigger="click" placement="top" @command="changePassword">
            <span class="el-dropdown-link">
              <img src="../../../../static/images/main/teacher_tx.svg" />
              <span class="user-name">{{userName}}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">修改密码</el-dropdown-item>
              <el-dropdown-item command="b">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </aside>
    <el-dialog title="" :visible.sync="dialogVisible" width="434px" :close-on-click-modal="false" custom-class="changePassword">
      <passwordChange :dialogVisible="dialogVisible" @refeshPaw="refeshPaw"></passwordChange>
    </el-dialog>
    <el-drawer
      title="迪小乐AI智能助手"
      :visible.sync="dxlMoveLayer.drawer"
      :direction="dxlMoveLayer.direction"
      :before-close="handleClose">
      <div class="dxl-move-class">
        <iframe :src="dxlMoveLayer.url" class="mover-ifranme" scrolling="no" frameborder="0"></iframe>
      </div>
      
    </el-drawer>

    <div class="iframe-container" v-if="commandUrl != ''">
      <iframe :src="commandUrl" frameborder="0" width="100%" height="100%" sandbox="allow-scripts allow-same-origin"></iframe>
    </div>

    <div 
      class="iframe-screen" 
      v-if="commandUrl != ''"
      @click="handleClickClose"
      @mouseenter="handleShowClose" 
      @mouseleave="handleHideClose" 
      @mousemove="handleShowTips" 
    ></div>

    <div id="closeTip" class="close-tip" style="">
      点击关闭
    </div>

    <el-dialog
      title="提示"
      :visible.sync="showDialogClose"
      width="30%"
    >
      <span>确定要关闭吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogClose = false">取 消</el-button>
        <el-button type="primary" @click="() => {showDialogClose = false; commandUrl = ''}">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import passwordChange from "./passwordChange";
import { mapState } from 'vuex';
import { allRead, getPersonMessageList, updateMsgState } from "@/api/datas.js";
export default {
  components: {
    passwordChange
  },
  data () {
    return {
      dialogVisible: false,
      activeName: '2',
      isShow: false,
      userName: null,
      message1: [],
      message2: [],
      count: 0,
      notifycount: 0,
      msg1Read: 0,
      msg2Read: 0,
      dxlMoveLayer: {
        drawer: false,
        direction: 'rtl',
        url: 'http://aigc.dlm.plus'
      },
      commandUrl: '',
      showClose: false,
      showDialogClose: false
    };
  },
  computed: {
    ...mapState(['isSidebarNavCollapse', 'crumbList'])
  },
  mounted () {
    // $(window).load(function () {
    // $('#msg').on("click", function () {
    //   var lis = $(this).find('li');
    //   console.log(lis);
    //   for (var i = 0; i < lis.length; i++) {
    //     lis[i].onclick = function () {
    //       console.log($(this));
    //       // lis[i].className = 'readMsg';
    //       $(this).addClass("readMsg");
    //     };
    //   }
    // });
    // });
    this.userName = this.$store.state.loginDatas.employ_name;
    document.addEventListener('click', this.bodyCloseMenus);
    //获取全部消息
    this.getAllMessage();
  },
  beforeDestroy () {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    // dbMsg (ul, i) {
    //   $('#' + ul).on("click", function () {
    //     $('#' + ul).find("li").eq(i).addClass("readMsg");
    //   });
    // },
    dbMsg (id) {
      updateMsgState({
        id: id
      })
        .then(res => {
          if (res.data.code == "200") {
            //console.log(res);
            this.getAllMessage();
          }
        });
    },
    messageyd () {
      allRead({
        employ_id: this.$store.state.loginDatas.id
      })
        .then(res => {
          if (res.data.code == "200") {
            //console.log(res);
            this.getAllMessage();
          }
        });
    },
    handleClick (tab) {
      this.getAllMessage();
    },
    getAllMessage () {
      getPersonMessageList({
        message_type: 3,
        employ_id: this.$store.state.loginDatas.id,
        notifyType: this.activeName
      })
        .then(res => {
          if (res.data.code == "200") {
            if (this.activeName == 2) {
              this.message1 = res.data.data;
            } else {
              this.message2 = res.data.data;
            }
            this.notifycount = res.data.notifycount;
            this.count = res.data.count;
          }
        });
    },
    bodyCloseMenus (e) {
      const self = this;
      if (self.isShow === true) {
        self.isShow = false;
      }
    },
    showMessage () {
      this.isShow = !this.isShow;
    },
    toggleNavCollapse () {
      this.$store.commit('toggleNavCollapse');
    },
    loginOut () {
      this.$store.commit('LOGIN_OUT');
      /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
      window.location.reload(true);
    },
    //修改密码
    changePassword (command) {
      if (command == "a") {
        this.dialogVisible = true;
      } else if (command == "b") {
        this.$confirm('确认退出账号吗?', '', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: '',
          customClass: "exit",
          cancelButtonClass: "cancelBtn",
          confirmButtonClass: "confirmBtn"
        }).then(() => {
          this.loginOut();
        }).catch(() => { });
      }
    },
    clientSelect (command) {
      // this.commandUrl = command;
      if (command === 'http://aigc.dlm.plus/') {
        // this.commandUrl = "https://aigc-proxy.delightmom.com/";
        this.commandUrl = "";
        window.open(command, '_blank');
      } else if (command === 'http://tool.dlm.plus/') {
        // this.commandUrl = "https://tool-proxy.delightmom.com/";
        window.open(command, '_blank');
      } else if (command === 'http://aiot.delightmom.com/login') {
        // this.commandUrl = "https://aiot-proxy.delightmom.com/";
        this.commandUrl = "";
        window.open(command, '_blank');
      }
    },
    refeshPaw (e) {
      this.dialogVisible = e;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    handleClickClose () {
      if (!this.showClose) {
        return;
      }
      // this.commandUrl = '';
      this.showDialogClose = true;
    },

    handleShowClose () {
      this.showClose = true;
    },

    handleHideClose () {
      this.showClose = false;
      // 获取提示元素（假设你有一个id为"closeTip"的元素）
      const tipElement = document.getElementById('closeTip');
      if (tipElement) {
        tipElement.style.display = 'none'; // 显示提示
      }
    },

    handleShowTips (e) {
      if (!this.showClose) {
        return;
      }
      // 获取鼠标当前位置（相对于视口）
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      
      // 获取提示元素（假设你有一个id为"closeTip"的元素）
      const tipElement = document.getElementById('closeTip');
      if (tipElement) {
        // 设置提示框位置（右下角偏移10px）
        tipElement.style.left = `${mouseX + 10}px`;
        tipElement.style.top = `${mouseY + 10}px`;
        tipElement.style.display = 'block'; // 显示提示
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 80px;
  background: linear-gradient(180deg, #26b1f2 0%, #09cbf9 100%);
}
.dxl-move-class {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .mover-ifranme{
    width: 80%;
    height: 99%;
    border: 1px solid #ebebeb;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
}
.aside__top {
  height: 80px;
  line-height: 80px;
  transition: left 0.25s;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logoBox {
    display: flex;
    align-items: center;
    .logo {
      width: 168px;
      height: 80px;
      img {
        width: 100%;
        height: auto;
      }
    }

    .logoText {
      color: #fff;
    }
  }

  .toggleNavCollapse {
    display: inline-block;
    margin-left: 8px;
    padding: 0 10px;
    font-size: 26px;
    vertical-align: middle;
    color: #333;
    cursor: pointer;
    transition: all 0.5s;

    &.active {
      transform: rotate(90deg);
    }
  }

  .aside__top--right {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .ai-box{
      color: #ffffff;
      cursor: pointer;
      user-select: none; /* 标准写法 */
      -webkit-user-select: none; /* Chrome, Safari, Opera, Edge */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      margin-right: 18px;
      .box-dropdown{
        color: #ffffff;
        margin-right: 18px;
      }
      ::after {
        content: "";
        position: absolute;
        height: 20px;
        top: 50%;
        right: -10px;
        top: 50%;
        margin-top: -10px;
        border-left: 1px solid #fff;
      }
    }
    .message {
      width: 60px;
      height: 60px;
      position: relative;
      margin-right: 10px;
      img {
        width: 100%;
        height: auto;
        cursor: pointer;
      }
      > span {
        position: absolute;
        width: 30px;
        height: 18px;
        text-align: center;
        right: -1px;
        top: 13px;
        font-size: 10px;
        color: #ffffff;
        line-height: 18px;
        background: red;
        border-radius: 10px;
      }
      &:after {
        content: "";
        position: absolute;
        height: 20px;
        top: 50%;
        right: -10px;
        top: 50%;
        margin-top: -10px;
        border-left: 1px solid #fff;
      }
      .messageCon {
        position: absolute;
        top: 80px;
        right: -20px;
        width: 318px;
        height: 327px;
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
        z-index: 10;
        &::before {
          content: "";
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #fff;
          position: absolute;
          top: -9px;
          right: 36px;
        }
        /deep/ .el-tabs__nav {
          width: 100%;
          height: 50px;
          line-height: 50px;
          .el-tabs__active-bar {
            width: 50% !important;
          }
          .el-tabs__item {
            width: 50%;
            text-align: center;
            padding: 0;
          }
        }
        /deep/ .el-tabs__content {
          .el-tab-pane {
            // padding: 0 16px;
            line-height: 20px;
            height: 194px;
            overflow-y: auto;
            ul li {
              font-size: 12px;
              color: #4f4f4f;
              padding: 10px 16px;
              overflow: hidden;
              cursor: pointer;
              &:hover {
                background: rgba(220, 244, 255, 0.8);
              }
              &.readMsg {
                opacity: 0.4;
              }
              // display: flex;
              // justify-content: center;
              & > div {
                display: block;
                width: 100%;
                clear: both;
                color: rgba(0, 0, 0, 0.85);
              }
              i {
                color: #999999;
                display: block;
                float: right;
              }
            }
          }
        }
        .btnBox {
          padding: 16px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-button {
            width: 132px;
            height: 34px;
            padding: 0;
            border-radius: 20px;
            border: 1px solid #26b1f2;
            color: #26b1f2;
            &:hover {
              background: #26b1f2;
              color: #fff;
            }
          }
        }
        .empt {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          img {
            width: 84px;
            height: auto;
          }
          h3 {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
          }
        }
      }
    }
    .user-msg {
      height: 80px;
    }
    > div {
      // &:hover::after {
      //   transform-origin: 0 0;
      //   transform: scaleX(1);
      // }

      // &:first-child:before {
      //   border: none;
      // }

      // &::after {
      //   content: "";
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   width: 100%;
      //   height: 2px;
      //   background: #ef4747;
      //   transform: scaleX(0);
      //   transform-origin: right 0;
      //   transition: transform 0.5s;
      // }

      // &::before {
      //   content: "";
      //   position: absolute;
      //   height: 20px;
      //   top: 50%;
      //   left: -8px;
      //   margin-top: -10px;
      //   border-left: 1px solid #ccc;
      // }

      // &.email {
      //   i {
      //     position: absolute;
      //     left: 18px;
      //     top: -12px;
      //     border-radius: 20px;
      //     background: red;
      //     color: #fff;
      //     text-align: center;
      //     font-size: 12px;
      //     line-height: 1.5;
      //     min-width: 20px;
      //     min-height: 20px;
      //   }
      // }

      &.user-msg {
        .user-img {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          vertical-align: middle;
        }
        .el-dropdown-link {
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 30px;
            height: auto;
            margin-left: 20px;
          }
        }
        .user-name {
          color: #fff;
          padding: 0 4px;
        }
      }
    }
  }
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.6s;
}

.breadcrumb-leave-active {
  position: absolute;
}
/deep/ .changePassword {
  .el-dialog__header {
    background: none;
    height: 60px;
  }
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 16px;
  height: 16px;
  background-color: #efefef;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #d0d1d1;
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px #d0d1d1;
}
// ::v-deep{
//   .el-dropdown-menu__item{
//     text-align: center;
//   }
// }

.iframe-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 90vh;
  border-radius: 10px;
  overflow: hidden;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.iframe-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.close-tip {
  position: fixed; 
  display: none; 
  pointer-events: none; 
  padding: 4px 8px; 
  background: #333; 
  color: white; 
  border-radius: 4px; 
  font-size: 12px;
  z-index: 1001;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/top-aside.vue